/* Publish by EComposer at 2026-09-25 15:18:59*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-a62lrjf8qg6"]=  window.__ectimmers["ecom-a62lrjf8qg6"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-a62lrjf8qg6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a62lrjf8qg6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6u199hmx5gf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6u199hmx5gf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ipn2sz09fgh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ipn2sz09fgh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dqs9cadda1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dqs9cadda1', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rl1s70nq2cl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rl1s70nq2cl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ljupf0fyfu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ljupf0fyfu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3n90s04o5zn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3n90s04o5zn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dvni8sxewn9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dvni8sxewn9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l00v41jhj3l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l00v41jhj3l', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mm4pc5qxqdh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mm4pc5qxqdh', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-fi81ecnh2oo"]=  window.__ectimmers["ecom-fi81ecnh2oo"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var t=this.$el.querySelector("[ecom-modal]");new window.EComModal(t,{cssClass:["ecom-container-lightbox-"+this.id]})}let e=this.$el;if(!e)return;function i(o){const s=o.getBoundingClientRect();return s.top>=0&&s.left>=0&&s.bottom-o.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&s.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let o=e.querySelector(".ecom-element.ecom-base-image"),s=e.closest(".core__row--columns");o&&(i(o)?(o.classList.add("image-highlight"),s.setAttribute("style","z-index: unset")):(o.classList.remove("image-highlight"),s.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-fi81ecnh2oo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fi81ecnh2oo', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-al14g72oap6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-al14g72oap6', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m5s99r9756').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m5s99r9756', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4mc9puzd9et').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4mc9puzd9et', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}